import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Optional,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { CaseDialogComponent } from './dialog/case-dialog.component';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SelectCaseDialogComponent } from '../actions/selectCaseDialog/select-case-dialog.component';
import { CreateCaseService } from './create-case.service';

import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { AppInitService } from '../../services/app-init.service';
import { User } from '../header/header.component';
import { DgOrgSearchComponent } from 'dg-org-search-lib';
import { Combo } from '../../models/combo.model';

@Component({
  selector: 'app-create_case',
  templateUrl: './create_case.component.html',
  styleUrls: ['./create_case.component.scss'],
})
export class CreateCaseComponent implements OnInit {
  @ViewChild('orgSearch') orgSearch: DgOrgSearchComponent;
  defaultCaseCreationLogic = 0;
  autoCloseRefreshWorklist = false;
  caseCreationComboTabVisible = false;
  deptList: any;
  roleList: any;
  sectionList: any;
  processList = [];
  roleGroups: any;
  selectedAttribute: any;
  content: any;
  selectedDepartment: any;
  selectedDepartmentId: any;
  selectedRole: any;
  selectedSection: any;
  createCase: FormGroup;
  type = new FormGroup({
    typeSelect: new FormControl('', Validators.required),
  });
  @Output() refreshWorklist = new EventEmitter<any>();
  data2 = [];
  fromCaseCorrbool = false;
  parentOrg: [];
  isDiscomEnabledTP: boolean = false;
  isSectionSelected: boolean = false;
  isDepartmentSelected: boolean = false;
  confidentialityList = [];
  OrdinaryOptionVal = null;
  //counts chracters in description
  maxChars = 2000;
  desc = '';
  chars = 0;

  @Input() multiple = true;
  @Input() width = '600px';

  details: any;
  subjectId: string;

  /* {
    "extendedVO": null,
    "customXidBean": null,
    "dbSchema": null,
    "optionValue": "6287098",
    "optionText": "Ele.Sub-Div, Tirtol (Para",
    "optionDesc": "",
    "attrValue": ""
} */
  typeList: Combo[] = [
    {
      extendedVO: null,
      customXidBean: null,
      dbSchema: null,
      optionValue: '1',
      optionText: 'Predefined Hierarchy',
      optionDesc: 'Top Secret',
      attrValue: '',
    },
    // {
    //   extendedVO: null,
    //   customXidBean: null,
    //   dbSchema: null,
    //   optionValue: '2',
    //   optionText: 'Generic Approval',
    //   optionDesc: 'Secret',
    //   attrValue: '3',
    // },
    {
      extendedVO: null,
      customXidBean: null,
      dbSchema: null,
      optionValue: '3',
      optionText: 'Dynamic Hierarchy',
      optionDesc: 'Confidential',
      attrValue: '',
    },
  ];

  selectedItem: any;
  hierarchyList = [];
  dynamic: FormGroup;
  processSelectList: any;
  unitId: unknown;
  unitArray: any;
  loginEmpName: unknown;
  loginOrgId: any;
  loginOrgName: any;
  selectedOrganization: any;
  selectedOrgs: any[];
  selectedIndex: any;
  refreshOrg: boolean = true;
  constructor(
    public dialog: MatDialog,
    private router: Router,
    private service: CreateCaseService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public matDialogRef: MatDialogRef<CreateCaseComponent>,
    private http: HttpClient,
    public translate: TranslateService,
    public appInitService: AppInitService
  ) {
    //ADDED FOR CORR CASES
    if (this.data?.data) {
      this.data = this.data.data;
    }
  }
  refreshComponent = true;
  selectedRow = {
    dataForPost: null,
    loggedOrgId: {
      optionValue: null,
      optionText: null,
    },
    hierarchyType: {
      optionValue: null,
      optionText: null,
    },
    organizationName: {
      name: null,
      id: null,
    },
    fromCreateCase: true,
    superAdminFlag: true,
    lgSubId: null,
    typeFlag: null,
    procressID: null,
    organizationId: null,
    processHrhcyTechnique: 2,
    lsbPk: null,
    slaConfigType: 0,
    isAuditPresent: null,
    processName: {
      optionValue: null,
      optionText: null,
    },
    rowCount: null,
    superAdmin: true,
  };
  onStepChange(data): void {
    console.log('On Step Change', data);
    this.selectedIndex = data?.selectedIndex;
  }
  setJsonValues() {
    if (this.createCase.get('description').value.length) {
      this.selectedRow.dataForPost = {
        // confidentialityId: Number(
        //   this.createCase.get('confidentiality').value.optionValue
        //     ? this.createCase.get('confidentiality').value.optionValue
        //     : this.confidentialityList[3].optionValue
        // ),
        confidentialityId: 72,
        caseDesc: this.createCase.get('description').value,
        deptId: Number(this.selectedOrgs[0]),
        sectionId: Number(this.selectedOrgs[0]),
        subjectId: Number(
          this.dynamic?.controls?.processSelect?.value?.optionValue
        ),
        physicalFlag: 0,
        caseOwnerUnit: Number(this.createCase?.get('role')?.value?.optionValue),
        cutOffTimeLimit: null,
        disposalTimeLimit: null,
        archivalTimeLimit: null,
        markType: -1,
        markRemarks: null,
        vitalRecord: 0,
        legalRemarks: null,
        restrictionFlag: 0,
        arrivalDate: '',
        arrivalTime: '',
        collId: null,

        isPartFile: -1,
        corrId: this.data?.[0]?.docId ? this.data?.[0]?.docId : 1697,
        corrStageId: 124,
        corrStatusId: 120,
        ruleParams: {
          empId: '2',
          docTypeIds: '5',
          folderId: '99',
          langId: '2',
          claimId: '75',
          claimAmount: '1000',
          billMonth: '10',
          claimApprovalMonth: '6',
          billPaidAmount: '5000',
          admissionMonth: '2',
          insuranceId: '10',
          monthOfRecharge: '5',
          gender: 'Male',
          hospitalId: '100',
          patientId: '500',
        },
        caseAdditionalDtlsVO: {
          attribute1: 'demoCheck1',
          attribute2: 'demoCheck2',
          attribute3: 'demoCheck3',
        },
        returnCaseObjAfterCaseCreation: false,
      };
    }
  }
  showHierarchy = false;
  onNextStep(i, type?: number): void {
    this.selectedIndex = i;
    // console.log(
    //   'selected process',
    //   this.selectedAttribute,
    //   this.selectedDepartmentId
    // );
    // // let selectedApi = this.processSelectList.find(
    // //   (s: any) => s?.optionValue == Number(this.selectedAttribute.subId)
    // // );
    // // this.dynamic.controls.processSelect.setValue(selectedApi);
    // // this.selectedOrgs = [Number(this.selectedDepartmentId?.optionValue)];
    // //  this.refreshOrg = false;
    // this.selectedRow.procressID = this.dynamic?.controls?.processSelect?.value?.optionValue;
    // this.selectedRow.processName = this.dynamic?.controls?.processSelect?.value;
    // if (this.createCase.get('description').value.length) {
    //   this.selectedRow.dataForPost = {
    //     // confidentialityId: Number(
    //     //   this.createCase.get('confidentiality').value.optionValue
    //     //     ? this.createCase.get('confidentiality').value.optionValue
    //     //     : this.confidentialityList[3].optionValue
    //     // ),
    //     confidentialityId: 72,
    //     caseDesc: this.createCase.get('description').value,
    //     deptId: Number(this.selectedOrgs[0]),
    //     sectionId: Number(this.selectedOrgs[0]),
    //     subjectId: Number(
    //       this.dynamic?.controls?.processSelect?.value?.optionValue
    //     ),
    //     physicalFlag: 0,
    //     caseOwnerUnit: Number(this.createCase?.get('role')?.value?.optionValue),
    //     cutOffTimeLimit: null,
    //     disposalTimeLimit: null,
    //     archivalTimeLimit: null,
    //     markType: -1,
    //     markRemarks: null,
    //     vitalRecord: 0,
    //     legalRemarks: null,
    //     restrictionFlag: 0,
    //     arrivalDate: '',
    //     arrivalTime: '',
    //     collId: null,
    //     isPartFile: -1,
    //     corrId: this.data?.[0]?.docId ? this.data?.[0]?.docId : 1697,
    //     corrStageId: 124,
    //     corrStatusId: 120,
    //     ruleParams: {
    //       empId: '2',
    //       docTypeIds: '5',
    //       folderId: '99',
    //       langId: '2',
    //       claimId: '75',
    //       claimAmount: '1000',
    //       billMonth: '10',
    //       claimApprovalMonth: '6',
    //       billPaidAmount: '5000',
    //       admissionMonth: '2',
    //       insuranceId: '10',
    //       monthOfRecharge: '5',
    //       gender: 'Male',
    //       hospitalId: '100',
    //       patientId: '500',
    //     },
    //     caseAdditionalDtlsVO: {
    //       attribute1: 'demoCheck1',
    //       attribute2: 'demoCheck2',
    //       attribute3: 'demoCheck3',
    //     },
    //     returnCaseObjAfterCaseCreation: false,
    //   };
    // }
    // // setTimeout(() => {
    // //  // this.refreshOrg = true;
    // //   //    this.ngOnInit();
    // // }, 100);
  }
  ngOnInit(): void {
    this.service
      .getCombo({
        ComboId: '6006',
      })
      .subscribe((res) => {
        const restemp: any = res;
        this.hierarchyList = restemp?.data;
      });
    this.service.getProfileData().subscribe((res) => {
      const restemp: any = res;
      this.content = restemp.data;
      this.appInitService?.getConfigurableFields()?.subscribe(() => {
        this.isDiscomEnabledTP = this.appInitService?.appConfig?.configurableFields?.isDiscomEnabledTP;
        this.caseCreationComboTabVisible = this.appInitService?.appConfig?.configurableFields?.caseCreationComboTabVisible;
        this.defaultCaseCreationLogic = this.appInitService?.appConfig?.configurableFields?.defaultCaseCreationLogic;
        this.autoCloseRefreshWorklist = this.appInitService?.appConfig?.configurableFields?.autoCloseRefreshWorklist;

        if (this.defaultCaseCreationLogic) {
          const selectedItem: any = this.typeList.find(
            (option) =>
              option.optionValue === this.defaultCaseCreationLogic.toString()
          );
          this.type.controls['typeSelect'].setValue(selectedItem);
        } else {
          this.type.controls['typeSelect'].setValue(null);
        }

        if (this.isDiscomEnabledTP) {
          this.populateDisccom(this.content);
        }
      });

      this.populateDepartment();
      this.subjectId = '50029271';
    });
    this.populateConfidentiality();
    this.populateProcessSelect();
    this.createCase = new FormGroup({
      disccom: new FormControl(null),
      department: new FormControl('', Validators.required),
      role: new FormControl('', Validators.required),
      section: new FormControl('', Validators.required), //Removed Validators.required
      process: new FormControl(null, Validators.required),
      description: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[^#]+$/),
      ]),
      confidentiality: new FormControl(null),
    });

    this.dynamic = new FormGroup({
      processSelect: new FormControl(null, Validators.required),
      orgname: new FormControl(null),
      orgId: new FormControl(null, Validators.required),
      hierarchy: new FormControl(null, Validators.required),
    });
    this.dynamic.controls.orgname.disable();
    this.service.methodForLoginDetails().subscribe((res: User) => {
      const restemp: User = res;
      this.unitId = restemp?.employeeVO?.unitId;
      this.unitArray = restemp?.employeeVO?.unitVO;
      this.loginEmpName = restemp?.employeeVO?.empFullName;

      this.Calculate();
    });

    try {
      if (this.data?.isFromCorr) {
        this.fromCaseCorr(this.data?.selectedData);
      }
    } catch (e) {}
  }
  orgConfig = {
    prntId: '54',
    fetchPrntOrgOnlyFlag: 'false',
    multiselect: false,
    header: 'Reporting Organization',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 or more characters',
  };
  onValueProcessChange(v) {
    this.selectedRow.procressID = v.optionValue;
    this.selectedRow.processName = v;
    this.refreshComponent = false;
    this.setJsonValues();
    if (
      Number(this.selectedRow.organizationId[0]) > 0 &&
      Number(this.dynamic?.controls?.processSelect?.value?.optionValue) > 0
    )
      this.service
        .checkHierarchy({
          orgId: this.selectedRow.organizationId[0],
          subjectId: Number(
            this.dynamic?.controls?.processSelect?.value?.optionValue
          ),
        })
        .subscribe((val: any) => {
          if (val?.data == false) this.showHierarchy = true;
          else this.showHierarchy = false;
          console.log('response', val);
        });
    setTimeout(() => {
      this.refreshComponent = true;
      //    this.ngOnInit();
    }, 100);
  }
  onValueHierarchyChange(v) {
    this.selectedRow.hierarchyType = v;
    this.selectedRow.typeFlag = v.optionValue;
    this.refreshComponent = false;
    this.setJsonValues();
    setTimeout(() => {
      this.refreshComponent = true;
      //    this.ngOnInit();
    }, 100);
  }
  Calculate() {
    this.unitArray?.forEach((unit) => {
      if (this.unitId == unit?.unitId) {
        this.loginOrgId = unit?.deptId;
        this.selectedOrgs = [this.loginOrgId];
        unit?.organizationVOArr.forEach((org) => {
          this.loginOrgName = org.organizationName;
          this.dynamic.controls.orgname.setValue(this.loginOrgName);
          // this.selectedRow.organizationName.name = this.loginOrgName;
          // this.selectedRow.organizationName.id = this.loginOrgId;
          // this.selectedRow.loggedOrgId.optionText = this.loginOrgName;
          // this.selectedRow.loggedOrgId.optionValue = this.loginOrgId;
          // this.selectedRow.organizationId = [this.loginOrgId];
          // this.empSearch.orgId = this.loginOrgId;
          // this.getAccessGrid();
        });
        return;
      }
    });
  }
  getOrgData(val) {
    this.dynamic.controls.orgId.setValue(val?.id);
    this.selectedOrganization = {
      organizationId: val?.id,
      organizationName: val?.name,
    };
    this.selectedRow.organizationName.name = this.selectedOrganization.organizationName;
    this.selectedRow.organizationName.id = this.selectedOrganization.organizationId;
    this.selectedRow.loggedOrgId.optionText = this.selectedOrganization.organizationName;
    this.selectedRow.loggedOrgId.optionValue = this.selectedOrganization.organizationId;
    this.selectedRow.organizationId = [
      this.selectedOrganization.organizationId,
    ];
    this.refreshComponent = false;
    if (
      Number(this.selectedRow?.organizationId[0]) > 0 &&
      Number(this.dynamic?.controls?.processSelect?.value?.optionValue) > 0
    )
      this.service
        .checkHierarchy({
          orgId: this.selectedRow.organizationId[0],
          subjectId: Number(
            this.dynamic?.controls?.processSelect?.value?.optionValue
          ),
        })
        .subscribe((val: any) => {
          if (val?.data == false) this.showHierarchy = true;
          else this.showHierarchy = false;
          console.log('response', val);
        });
    this.setJsonValues();
    setTimeout(() => {
      this.refreshComponent = true;
      //    this.ngOnInit();
    }, 100);
  }
  onValueChange(v) {
    if (this.type?.controls?.typeSelect?.value == '3') {
      this.orgSearch?.orgSearchFormGroup?.controls?.orgSearchFormControl?.disable();
    }
  }
  populateDisccom(profileData) {
    console.log('profile Data', profileData);
    if (profileData?.orgId) {
      this.http
        .get('/admin/parent-organization-details', {
          params: {
            prntId: profileData?.orgId,
          },
        })
        .subscribe((res) => {
          const resTmp: any = res;
          console.log('parent org data', resTmp.data);
          this.parentOrg = resTmp.data;
          this.parentOrg.forEach((element: any) => {
            if (element?.typeId === 12) {
              this.createCase?.controls['disccom']?.setValue(element?.name);
              this.createCase?.controls['disccom']?.disable();
            }
          });
        });
    }
  }

  fromCaseCorr(data): void {
    this.fromCaseCorrbool = true;
    this.http
      .get(
        '/correspondence-mgmnt/correspondence-dtls?' + 'corrId=' + data.docId
      )
      .subscribe((res: any) => {
        const restmp = res;
        console.log(' called data=======', restmp);
        this.details = restmp.data;
        const deptValues = {
          optionText: this.details.sectionName,
          optionValue: this.details.sectionID,
        };
        const roleValues = {
          optionText: this.details.corrTypeName,
          optionValue: this.details.crntOwnerUnit,
        };
        const sectValues = {
          optionText: this.details.sectionName,
          optionValue: this.details.sectionID,
        };
        const subValues = {
          subName: this.details.subjectName,
          subId: this.details.subjectID,
        };
        this.selectedDepartment = deptValues;
        this.selectedRole = roleValues;
        this.selectedSection = sectValues;
        this.selectedAttribute = subValues;
        this.desc = data.description;
        this.createCase.controls['department'].setValue(
          this.selectedDepartment
        );
        this.createCase.controls['department'].disable();
        this.createCase.controls['role'].setValue(this.selectedRole);

        this.createCase.controls['role'].disable();
        this.createCase.controls['section'].setValue(this.selectedSection);
        this.createCase.controls['section'].disable();
        this.createCase.controls['process'].setValue(this.selectedAttribute);
        this.createCase.controls['process'].disable();
        this.createCase?.controls['description'].setValue(this.desc);
      });
  }

  populateDepartment(): void {
    const dataforpost = {
      EMP_ID: this.content.empId,
      ComboId: '3505',
    };
    //this.http.post('/worklist/logged-in-user-departments', dataforpost)
    this.service.getDepartmentList(dataforpost).subscribe((res) => {
      const restemp: any = res;
      this.deptList = restemp.data;
      if (this.deptList?.length === 1) {
        this.createCase?.controls['department']?.setValue(this.deptList[0]);
        this.selectedDepartmentId = this.deptList[0];
        this.populateProcess(this.processList);
      }
      if (this.createCase?.controls['department']?.value?.optionValue) {
        this.createCase?.controls['department']?.setValue(
          this.createCase?.controls['department']?.value
        );
        this.onClickDepartment();
      }
      if (restemp.data.length == 1 && this.fromCaseCorrbool == false) {
        this.selectedDepartment = null;
      }
    });
  }

  onClickDepartment(): void {
    if (!this.selectedDepartmentId) {
      this.selectedDepartment = this.createCase?.controls[
        'department'
      ]?.value?.optionValue;
    }
    if (this.createCase.get('department').value) {
      this.populateSection();
      this.populateProcess(this.processList);
    } else {
      this.roleList = [];
      this.sectionList = [];
    }
  }

  populateSection(): void {
    const dataforpost = {
      ACTIVE_FLAG: 1,
      EMP_ID: this.content.empId,
      PRNT_ORGANIZATION_ID: this.createCase.get('department').value.optionValue,
      LANG_ID: 1,
      ORGANIZATION_TYPE: 14,
      ComboId: '3000000045',
    };
    //this.http.post('/worklist/get-combo-list', dataforpost)
    this.service.getCombo(dataforpost).subscribe((res) => {
      const restemp: any = res;
      this.sectionList = restemp.data;
      if (this.sectionList?.length === 1) {
        this.createCase?.controls['section']?.setValue(this.sectionList[0]);
        this.selectedSection = this.sectionList[0];
      }
      if (this.selectedSection) {
        this.createCase?.controls['section']?.setValue(this.selectedSection);
        this.populateRole();
      }
    });
  }

  populateRole(): void {
    const dataforpost = {
      ORGANIZATION_ID: this.createCase.get('section').value.optionValue,
      ComboId: '3000000307',
    };
    //this.http.post('/worklist/get-combo-list', dataforpost)
    this.service.getCombo(dataforpost).subscribe((res) => {
      const restemp: any = res;
      this.roleList = restemp.data;
      if (this.roleList.length == 1) {
        //this.selectedRole = null;
        this.createCase?.controls['role']?.setValue(this.roleList[0]);
        this.selectedRole = this.roleList[0].optionText;
        this.selectedRole = this.roleList[0];
        this.onChangeSectionAndRole();
      }
      if (this.selectedRole) {
        this.createCase?.controls['role']?.setValue(this.selectedRole);
        this.onChangeSectionAndRole();
      }
    });
  }

  populateProcess(result): void {
    if (result) {
      this.selectedAttribute = { subId: result.subId, subName: result.subName };
    }
  }
  populateConfidentiality(): void {
    const dataforpost = {
      ComboId: '1081',
      LANG_ID: 1,
    };
    this.service.getCombo(dataforpost).subscribe((res) => {
      const resTmp: any = res;
      console.log('Confidentialityyy', resTmp);
      this.confidentialityList = resTmp.data;
    });
  }

  onSubmit(): void {
    console.log('data of submit', this.data);
    if (this.createCase.valid) {
      const dataforpost = {
        // confidentialityId: Number(
        //   this.createCase.get('confidentiality').value.optionValue
        //     ? this.createCase.get('confidentiality').value.optionValue
        //     : this.confidentialityList[3].optionValue
        // ),
        confidentialityId: 72,
        caseDesc: this.createCase.get('description').value,
        deptId: Number(this.createCase.get('department').value.optionValue),
        sectionId: Number(this.createCase.get('section').value.optionValue),
        subjectId: Number(this.createCase.get('process').value.subId),
        physicalFlag: 0,
        caseOwnerUnit: Number(this.createCase.get('role').value.optionValue),
        cutOffTimeLimit: null,
        disposalTimeLimit: null,
        archivalTimeLimit: null,
        markType: -1,
        markRemarks: null,
        vitalRecord: 0,
        legalRemarks: null,
        restrictionFlag: 0,
        arrivalDate: '',
        arrivalTime: '',
        collId: null,

        isPartFile: -1,
        corrId: this.data?.[0]?.docId ? this.data?.[0]?.docId : 1697,
        corrStageId: 124,
        corrStatusId: 120,
        ruleParams: {
          empId: '2',
          docTypeIds: '5',
          folderId: '99',
          langId: '2',
          claimId: '75',
          claimAmount: '1000',
          billMonth: '10',
          claimApprovalMonth: '6',
          billPaidAmount: '5000',
          admissionMonth: '2',
          insuranceId: '10',
          monthOfRecharge: '5',
          gender: 'Male',
          hospitalId: '100',
          patientId: '500',
        },
        caseAdditionalDtlsVO: {
          attribute1: 'demoCheck1',
          attribute2: 'demoCheck2',
          attribute3: 'demoCheck3',
        },
        returnCaseObjAfterCaseCreation: false,
      };

      if (
        this?.fromCaseCorrbool ||
        this.data?.[0]?.appTypeId == '3' ||
        this.data?.appTypeId == '3'
      ) {
        //this.http.post('/case-mgmnt/create-case-frm-corr', dataforpost)
        this.service.fromCaseCorrApi(dataforpost).subscribe((val) => {
          this.createCase.reset();
          this.matDialogRef.close(true);
        });
      } else {
        //this.http.post('/case-mgmnt/cases', dataforpost)
        this.service.createCase(dataforpost).subscribe((val) => {
          if (this.type?.controls.typeSelect.value == '3') {
            this.onNextStep(1);
          } else {
            this.createCase.reset();
            if (this.autoCloseRefreshWorklist) {
              this.refreshWorklist.emit(true);
            }
            if (dataforpost?.returnCaseObjAfterCaseCreation) {
              this.refreshWorklist.emit(val);
            } else {
              this.refreshWorklist.emit();
            }
          }
        });
      }
    }
  }
  onHierarchyRefresh(val) {
    this.refreshWorklist.emit(val);
  }
  openDialog(): void {
    this.data2 = [];

    if (
      this.createCase.get('role').value &&
      this.createCase.get('section').value
    ) {
      const dialogJson = {
        contentData: this.processList,
      };
      const dialogRef = this.dialog.open(CaseDialogComponent, {
        disableClose: true,
        width: this.width,
        data: dialogJson,
      });

      dialogRef.afterClosed().subscribe((result) => {
        try {
          if (result) {
            this.populateProcess(result);
          }
        } catch (err) {}
      });
    } else {
      this.dialog.open(SelectCaseDialogComponent, {
        data: this.translate.instant(
          'Create_case.Please_select_Role_and_Section'
        ),
      });
    }
  }
  handleResult(result: any): void {}

  onClickSection(): void {
    if (!this.createCase.get('department').value) {
      this.dialog.open(SelectCaseDialogComponent, {
        data: this.translate.instant('Create_case.Please_select_Department'),
      });
      this.sectionList = [];
    } else if (this.createCase.get('section').value) {
      this.populateRole();
    }
  }

  /*onClickSection(): void {
    if (!this.createCase.get('department').value) {
      this.dialog.open(SelectCaseDialogComponent, {
        data: this.translate.instant("Create_case.Please_select_Department"),
      });
      this.sectionList = [];
    }
  }*/

  onChangeSectionAndRole(): void {
    this.selectedAttribute = null;
    this.isSectionSelected = !!this.selectedSection;
    /*this.createCase.controls['process'].setValue(null);*/
    this.processList = [];
    if (this.createCase.get('section')?.value?.optionValue == null) {
      this.createCase.controls['process'].setValue(null);
      this.createCase.controls['role'].setValue(null);
    }
    if (this.createCase.get('role')?.value?.optionValue == null) {
      this.createCase.controls['process'].setValue(null);
    }
    if (
      this.createCase.get('role')?.value?.optionValue &&
      this.createCase.get('section')?.value?.optionValue
    ) {
      //this.http.get('/case-mgmnt/subjects', { params: {unitId: this.createCase.get('role').value.optionValue,sectionId: this.createCase.get('section').value.optionValue,}})
      this.service.getSubjects(this.createCase).subscribe((res: any) => {
        this.processList = res?.data;
      });
    }
  }
  populateProcessSelect(processId = null): void {
    this.service
      .getComboData('6004', {
        ACTIVE_FLAG: 1,
      })
      .subscribe((processList: any) => {
        this.processSelectList = processList;
        if (processId) {
          //  this.docForm.controls['process'].setValue(processId);
        }
      });
  }

  onChangeDepartment(): void {
    this.isDepartmentSelected = !!this.selectedDepartmentId;
    if (!this.isDepartmentSelected) {
      this.selectedSection = null;
      this.selectedRole = null;
      this.processList = null;
    }
    this.createCase.controls['process'].setValue(null);
    this.createCase.controls['role'].setValue(null);
    this.createCase.controls['section'].setValue(null);
  }

  onClose(): void {
    void this.router.navigateByUrl('/main');
  }

  onReset(): void {
    const disccomValue = this.createCase.get('disccom').value;
    this.roleGroups = [];
    this.roleList = [];
    this.sectionList = [];
    this.createCase.reset({ disccom: disccomValue });
    this.maxChars = 2000;
    this.desc = '';
  }
}
